import React from 'react'

import Homepage from './homepage'
import Features from './features'
import RewardDesc from './rewardDesc'
import Leaderboard from './leaderboard'
import Demovideo from './demovideo'

const landingpage = () => {
    return (
        <>
            <Homepage/>
            <Features/>
            <RewardDesc/>
            <Leaderboard/>
            <Demovideo/>
        </>
    )
}

export default landingpage
